import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

//components

import BreadCrumb from "@surgia/ui/components/breadCrumb";
import Button from "@surgia/ui/components/button";
import TabNavigation from "@surgia/ui/components/tabNavigation";
import GenericModal from "@surgia/ui/components/genericModal";
import { InviteUserForm } from "../../containers/forms/inviteUserForm";
//constants
import { BranchDetailTabs } from "./constant";
import inviteIcon from "@surgia/ui/icons/users/inviite.svg";
import { useQuery } from "@tanstack/react-query";
import { usersQueries } from "@surgia/api/src/queryStore/shared/users";

//helpers
import { getLocalStorageItem } from "../Catalog";

//tabs
import General from "./tabs/general";
import Users from "./tabs/users";
import PurchaseRequest from "./tabs/purchaseRequest";
import { checkUserPermissions } from "@surgia/utils";
import { permissions } from "../../permissions";
import { useSendInvitation } from "../../hooks/useSendInvitation";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
const tenant_id = getLocalStorageItem("tenant_id", null);
const BranchDetails: React.FC = () => {
  const { t } = useTranslation();
  const { id: branchId, branch_name: branchName } = useParams();
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const TARGET_COMPONENT_ID =
    import.meta.env.VITE_VITEAUTH_URL?.includes("test") ||
    import.meta.env.VITE_VITEAUTH_URL?.includes("develop")
      ? 8
      : 6;
  // states
  const { sendInvitation, isPending } = useSendInvitation();

  const [showInviteModal, setShowInviteModal] = useState(false);
  const [activeTab, setActiveTab] = useState("general");
  // quieries and mutations
  const onSubmit = (data: any) => {
    sendInvitation({
      tenant_id: tenant_id,
      email: data.email,
      user_group_ids_list: [parseInt(data.role)],
      branch_ids_list: [parseInt(branchId!)],
      component_id: import.meta.env.VITE_PUBLIC_COMPONENT_ID,
    });

    setShowInviteModal(false);
  };
  // handlers
  // Add the userGroups query
  const { data: userGroupsResponse } = useQuery({
    ...usersQueries.queries.getUserGroups({
      component_id: import.meta.env.VITE_PUBLIC_COMPONENT_ID,
      tenant_id: tenant_id,
      target_component_id: TARGET_COMPONENT_ID,
      target_tenant_id: tenant_id,
    }),
  });

  // Extract userGroups from the response
  const userGroups = userGroupsResponse?.data || [];

  const userPermissions = useSelector(
    (state: RootState) =>
      state.auth.globalState.user_permissions?.map(
        (permission) => permission.name
      ) || []
  );

  return (
    <div dir={isRTL ? "rtl" : "ltr"}>
      {/* Top header section */}
      <BreadCrumb
        items={[
          { label: t("admin.tenantDetails.breadcrumb.tenants"), show: true },
          {
            label: t("admin.tenantDetails.breadcrumb.tenantDetails"),
            show: true,
          },
        ]}
      />
      <div className="flex justify-between items-center my-[10px]">
        <div>
          <h1 className="page-title ">{branchName}</h1>
          <p className="text-gray-500 mt-1">{branchId}</p>
        </div>
        <Button
          variant="outline"
          onClick={() => setShowInviteModal(true)}
          disabled={
            !checkUserPermissions([
              permissions.INVITATION_CREATE,
              permissions.USER_CREATE,
              permissions.VIEW_USER_GROUPS,
            ]) || isPending
          }
        >
          {isPending ? "Sending invitation..." : "Add User"}
        </Button>
      </div>
      <TabNavigation
        tabs={BranchDetailTabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      {/* Conditional Content Rendering */}
      {activeTab === "general" && <General />}

      {activeTab === "users" && <Users />}

      {activeTab === "purchase-requests" &&
        userPermissions.includes(permissions.VIEW_DRAFT_PURCHASE_REQUEST) && (
          <PurchaseRequest />
        )}

      <GenericModal
        title="Invite new user"
        subtitle="Add a new user to your tenant account here and assign their role."
        open={showInviteModal}
        onClose={() => setShowInviteModal(false)}
        titleIcon={<img src={inviteIcon} alt="Invite" className="w-10 h-10" />}
        additionalTitleStyles="!mb-0 text-[16px]"
        additionalSubtitleStyles="!text-[14px]"
        footer={<></>}
      >
        <InviteUserForm
          onSuccess={onSubmit}
          onCancel={() => setShowInviteModal(false)}
          showBranches={false}
          userGroups={userGroups}
          branches={[]}
        />
      </GenericModal>
    </div>
  );
};

export default BranchDetails;
